import React from 'react';

export default props => (
  <img alt="Checkbox Icon" {...props} />
);
